import { FormControl, FormGroup } from '@angular/forms';
import * as i0 from "@angular/core";
export class FormValidatorsService {
    constructor() { }
    validateAllFormFields(formGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            }
            else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }
    validate(formGroup) {
        this.validateAllFormFields(formGroup);
        return formGroup.valid;
    }
    resetField(formGroup, field) {
        formGroup.get(field).reset();
        formGroup.get(field).markAsPristine();
        formGroup.get(field).markAsUntouched();
    }
    reset(formGroup) {
        formGroup.reset();
        formGroup.markAsPristine();
        formGroup.markAsUntouched();
    }
    selectFirstOrDefault(control, options, optionValuePropName = 'value') {
        if (options.length === 0) {
            // control.setValue(options[0][optionValuePropName])
            return;
        }
        if (options.length > 0)
            control.setValue(options[0][optionValuePropName]);
    }
    selectDefaultFormatoProducto(control, options, optionValuePropName = 'value') {
        if (options.length === 0)
            return;
        if (options.length > 0) {
            const defaults = options.filter(formato => formato.formato_codigo === formato.formato_codigo_top);
            if (defaults.length > 0)
                control.setValue(defaults[0][optionValuePropName]);
            else
                control.setValue(options[0][optionValuePropName]);
        }
    }
    setDefaultValues(formGroup, defaultValues) {
        for (const [key, value] of Object.entries(defaultValues)) {
            formGroup.get(`${key}`).setValue(value);
            formGroup.get(`${key}`).markAsPristine();
            formGroup.get(`${key}`).markAsUntouched();
        }
    }
    setInitialState(formGroup, initialValues) {
        formGroup.reset();
        this.setDefaultValues(formGroup, initialValues);
        formGroup.markAsPristine();
        formGroup.markAsUntouched();
    }
    obtenerValorFormHeader(formGroup, formControlName) {
        // Activar y desactivar según corresponda para obtener el valor. (desactivado el valor es null, por eso se activa antes de obtener su valor)
        const formControlState = formGroup.get(formControlName).enabled;
        formGroup.get(formControlName).enable();
        const formControlValue = formGroup.get(formControlName).value;
        if (formControlState)
            formGroup.get(formControlName).enable();
        else
            formGroup.get(formControlName).disable();
        return formControlValue;
    }
}
FormValidatorsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FormValidatorsService_Factory() { return new FormValidatorsService(); }, token: FormValidatorsService, providedIn: "root" });
